import dayjs from 'dayjs';

import { useReportsSlice } from 'entities/Report';
import { EFilters } from 'features/Filters';
import { formatDate } from 'shared/utils';

import 'dayjs/locale/ru';

import { useFilters } from './useFilters';

dayjs.locale('ru');

export const useDateFilters = (after: EFilters, before: EFilters, isStore?: boolean) => {
	const { getFilterValue, onFilterChange } = useFilters();
	const { chartFilters, setFilter } = useReportsSlice();

	const valueAfter = isStore ? chartFilters[after] : getFilterValue(after);
	const valueBefore = isStore ? chartFilters[before] : getFilterValue(before);

	return {
		dateAfter: valueAfter ? dayjs(valueAfter) : null,
		dateBefore: valueBefore ? dayjs(valueBefore) : null,
		onDateChange: (value: dayjs.Dayjs | null, key: EFilters, isDateTime?: boolean, isToFilter?: boolean) => {
			const date = value?.toDate() || null;

			if (isStore) {
				setFilter({ name: key, value: formatDate(date, 'iso') || null });
			} else {
				onFilterChange(key, formatDate(date, isDateTime ? 'json' : 'iso', isToFilter ? 'to' : 'from') || '');
			}
		},
	};
};
